import { shallowEqual, useSelector } from 'react-redux';
import { getSalesSelectedIdentifiers } from '../../selector';

export const useSalesSelectedIdentifiers = () => ({
  selected: useSelector(getSalesSelectedIdentifiers, shallowEqual),
});
